import e from "@dialpad/dialtone-tokens/layered/themes/tokens-sunflower-colors.css?inline";
//#region themes/sunflower.js
var t = { brand: {
	css: e,
	name: "sunflower"
} };
//#endregion
export { t as default };
